var singleProductSlider=null;

(function($){
	
	/* document ready */
	$(document).on('ready', function(){
		
		// blink fields
		$(document).on('focus', 'input, textarea', function(){
			if($(this).attr('value') == $(this).attr('title')) $(this).val('');
		}).on('blur', 'input, textarea', function(){
			if($(this).attr('value') == '') $(this).val($(this).attr('title'));
		});

		// init custom scroll
		$('.mini-bag .scrollarea').jScrollPane({
			verticalGutter: 0,
			autoReinitialise: true
		});

		// mini bag toggle
		var mini_bag = $('.mini-bag');
		$('#hbar .bag-trigger').on('click', function(){
			mini_bag.toggleClass('visible');
			return false;
		});

		// close mini bag
		$('.mini-bag .close').on('click', function(){
			mini_bag.removeClass('visible');
			return false;
		});

		// init home slideshow
		var homeLiCount = $('.featured-big ul li').length,
			sliderNav = $('.featured-big-nav');
		$('.featured-big ul').jcarousel({
			auto: 3,
			scroll: 1,
			wrap: 'circular',
			initCallback: function(carousel){
				$('.featured-big ul li').each(function(){
					sliderNav.append('<a href="#" />');
				});

				$(document).on('click', '.featured-big-nav a', function(){
					carousel.scroll($(this).index()+1);
					return false;
				});
			},
			itemFirstInCallback: function(carousel, li, idx){
				var idx = idx>0 ? (idx-1)%homeLiCount+1 : homeLiCount + (idx%homeLiCount);
				$('a', sliderNav).removeClass('current').eq(idx-1).addClass('current');
			}
		});

		// custom selectbox
		$('.selectbox').c2Selectbox();

		// add table classes class
		$('.order-history tr:nth-child(even)').addClass('even');
		$('.order-history tr td:last-child').addClass('last');

		// init lookbook slider
		$('.lookbook-slider ul').jcarousel({
			auto: 0,
			scroll: 1
		});

		// make ajax request
    	var ajaxContainer = $('.lookbook-ajax-results');
        function lookbook_select(id){
            $($('.side-nav .current li').removeClass('current')[id]).addClass('current');
            var href=$($('.lookbook-slider li').removeClass('selected')[id]).addClass('selected').find('a').attr('href');
            
    		$.ajax({
				url: href,
				type: 'GET',
				dataType: 'html',
				success: function(data){
					ajaxContainer.empty().append($(data).find('.products'));
				}
			});
        }
        $('.lookbook-slider li > a').on('click', function(){
            lookbook_select($(this).parent().index());
            return false;
        });
        $('.side-nav .lookbook li > a').on('click', function(){
            lookbook_select($(this).parent().index());
            return false;
        });

		// init related products slider 
		$('.related-products .carousel ul').jcarousel({
			auto: 0,
			scroll: 1,
			wrap: 'both'
		});

		// fancybox
		$('.open-popup').fancybox({
			helpers: {
				overlay: {
					opacity: 0.6
				}
			},
			type: 'ajax',
			padding: 5,
			tpl: {
				closeBtn: '<div title="Close" class="fancybox-item fancybox-close agcb">Close X</div>'
			}
		});
        
        $('.image-popup').fancybox({
        	helpers: {
				overlay: {
					opacity: 0.6
				}
			},
			padding: 5,
			tpl: {
				closeBtn: '<div title="Close" class="fancybox-item fancybox-close agcb">Close X</div>'
			}
        });

		$('.open-quick-view').fancybox({
			helpers: {
				overlay: {
					opacity: 0
				}
			},
			scrolling: false,
			padding: 0,
			tpl: {
				closeBtn: '<div title="Close" class="fancybox-item fancybox-close agcb">Close X</div>'
			},
			beforeShow: function(){
				$('.fancybox-wrap').addClass('fancybox-quick-view');
			},
            afterShow: function(){
                $('.fancybox-inner').children().trigger('popup');  
            },
			afterClose: function(){
				$('.fancybox-wrap').removeClass('fancybox-quick-view');
			}
		});
        
        $('.popup-form').fancybox({
			scrolling: false,
			padding: 5,
			tpl: {
				closeBtn: ''
			},
    		beforeShow: function(){
				$('.fancybox-wrap').addClass('fancybox-form');
			},
            afterShow: function(){
                $('.fancybox-inner .select').c2Selectbox();
            },
    		afterClose: function(){
				$('.fancybox-wrap').removeClass('fancybox-form');
			}
		});

		// custom upload form
		$(document).on('mousemove', '.custom-upload', function(e){
			var pageX = e.pageX;
			var pageY = e.pageY;
			var thisOffsetY = $(this).offset().top;
			var thisOffsetX = $(this).offset().left;
			$(this).find('input').css({
				'left': pageX - thisOffsetX - 160,
				'top': pageY - thisOffsetY - 30
			})
			//Get File Name
			$(document).on('change', '.custom-upload input', function(){ 
				var inputVal = $(this).val();
				var inputValArr = inputVal.split("\\");
				var fileName = inputValArr[inputValArr.length - 1];
				$(this).parent().find('.filename').text(fileName);
			});
		});

		// submit  form
		$(document).on('submit', '#personal-shopper form, #subscribe form', function(){
			$('.form-inner', $(this)).hide().next('.form-success').show();
			return false;
		});

		// submit  form
		$(document).on('submit', 'form.intro-subscribe', function(){
			$(this).parents('.form-wrap').hide().next('.form-success').show();
			return false;
		});

	});
})(jQuery);